import BrowserDetect from "./BrowserDetect";
import Responsive from "./Responsive";
import SmoothScroll from "./SmoothScroll";
import Accordion from "./Accordion";
import Tab from "./Tab";
import SpNavi from "./SpNavi";
import ToTop from "./ToTop";
import DropDownMenu from "./DropDownMenu";
import BlockLink from "./BlockLink";
import Gmap from "./Gmap";
import matchheight from "jquery-match-height";
import link_icon from "./link_icon";
import inview from "jquery-inview";
import Swiper from 'swiper/dist/js/swiper.js';
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
let param = {
	target: "#spnavi",
	trigger: ".btn_sp_navi",
	filter: "resposive_flg",
	speed: 200
};
const spnavi = new SpNavi(param);
spnavi.exec();

/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop("#totop", "#global_footer", 100, 400);
totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
link_icon();

/**
 * audio js
 */
audiojs.events.ready(function() {
	const as = audiojs.createAll();
});

$('audio').each(function(){
	$(this).wrap('<div class="audio_wrapper"></div>');
	let file = $(this).attr('src');
	$(this).after('<a class="pc btn_audio_dl" href="'+file+'" download>download</a>');
})

if(document.documentMode && navigator.msSaveOrOpenBlob){
	window.addEventListener("click", function(eve){
		let a = eve.target
		if(!a.hasAttribute("download")) return
		eve.preventDefault()
		let filename = a.getAttribute("download")
		let xhr = new XMLHttpRequest()
		xhr.open("GET", a.href)
		xhr.responseType = "blob"
		xhr.send()
		xhr.onload = function(){
			navigator.msSaveOrOpenBlob(xhr.response, filename)
		}
	})
}
/**
 * home MV
 */
if($('.swiper-container').length > 0){
	$(".p-hero_logo").addClass("-is-active");
	setTimeout(()=>{
		//$(".p-hero_image").addClass("-is-active");
		let homeSwiper = new Swiper ('.swiper-container', {
		  spaceBetween: 0,
		  centeredSlides : true,
		  loop:true,
		  slidesPerView: 1,
		  autoplay: {
		    delay: 5000,
		  },
		  speed: 1800,
		  effect:'fade',
		  fadeEffect: {
		    crossFade: true
		  }
		});
	},500);
}
